import { AxiosPromise } from 'axios'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export interface InvoiceListQuery {
  page?: number
  page_size?: number
  advance_id?: string
  customer_name?: string
  adv_id?: number | string
  estimate_company_code?: string
  manual_invoice_id?: string
  created_by?: number | string
  has_refund?: number
  invoice_status?: number
  start_date?: string
  end_date?: string
}

export interface CreateInvoicePayload {
  adv_id: number
  customer_id: number
  estimate_company_code: string
  estimate_company_name: string
  traffic_type: string
  currency: string
  tax_rate: number
  tax: number
  amount: number
  actual_amount: number
  receipt_status: number
  remark?: string
  attachments: Array<{ file_name: string; file_url: string }>
}

export function fetchInvoiceList(params: InvoiceListQuery): AxiosPromise {
  return request({
    url: `${v2Host}/finance/invoice/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function createInvoice(data: CreateInvoicePayload): AxiosPromise {
  return request({
    url: `${v2Host}/finance/invoice/create`,
    method: 'post',
    data,
  })
}

export function deleteInvoice(data: { id: number | string }): AxiosPromise {
  return request({
    url: `${v2Host}/finance/invoice/delete`,
    method: 'post',
    data,
  })
}

export function retryPushInvoice(data: { id: number | string }): AxiosPromise {
  return request({
    url: `${v2Host}/finance/invoice/repush`,
    method: 'post',
    data,
  })
}

export function reissueInvoice(data: { id: number | string }): AxiosPromise {
  return request({
    url: `${v2Host}/finance/invoice/reissue`,
    method: 'post',
    data,
  })
}
